var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C5.01035 5 5.02063 4.99969 5.03083 4.99906C5.27646 6.97267 6.95987 8.5 9 8.5C11.2091 8.5 13 6.70914 13 4.5C13 2.29086 11.2091 0.5 9 0.5C6.95987 0.5 5.27646 2.02733 5.03083 4.00094C5.02063 4.00031 5.01035 4 5 4H1C0.723858 4 0.5 4.22386 0.5 4.5C0.5 4.77614 0.723858 5 1 5H5ZM9 1.5C7.34315 1.5 6 2.84315 6 4.5C6 6.15685 7.34315 7.5 9 7.5C10.6569 7.5 12 6.15685 12 4.5C12 2.84315 10.6569 1.5 9 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4C14.7239 4 14.5 4.22386 14.5 4.5C14.5 4.77614 14.7239 5 15 5H21C21.2761 5 21.5 4.77614 21.5 4.5C21.5 4.22386 21.2761 4 21 4H15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9692 15.9991C16.7235 17.9727 15.0401 19.5 13 19.5C10.7909 19.5 9 17.7091 9 15.5C9 13.2909 10.7909 11.5 13 11.5C15.0401 11.5 16.7235 13.0273 16.9692 15.0009C16.9794 15.0003 16.9896 15 17 15H21C21.2761 15 21.5 15.2239 21.5 15.5C21.5 15.7761 21.2761 16 21 16H17C16.9896 16 16.9794 15.9997 16.9692 15.9991ZM10 15.5C10 13.8431 11.3431 12.5 13 12.5C14.6569 12.5 16 13.8431 16 15.5C16 17.1569 14.6569 18.5 13 18.5C11.3431 18.5 10 17.1569 10 15.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.5C0.5 15.2239 0.723858 15 1 15H7C7.27614 15 7.5 15.2239 7.5 15.5C7.5 15.7761 7.27614 16 7 16H1C0.723858 16 0.5 15.7761 0.5 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.28b84f9e0f5074e01ad64d7574391dd5.svg";
export { ForwardRef as ReactComponent };